module.exports = __webpack_public_path__ + "img/pool-and-bio-pool.507545e0.jpg";